/**
 * Mirrors mobile BossDashboardPages — extend when new boss-dashboard screens ship.
 * Stored pageTitle on each activity doc overrides these titles when present.
 */
export const BOSS_DASHBOARD_PAGE_META = {
  dashboard: { number: 1, title: "Dashboard" },
  scheme_report: { number: 2, title: "Scheme report" },
  sales_report: { number: 3, title: "Sales report" },
  stock_report: { number: 4, title: "Stock report" },
  party_ledger: { number: 5, title: "Party ledger" },
  credit_due: { number: 6, title: "Credit / Due" },
  profit_loss: { number: 7, title: "Profit & loss" },
  pending_orders: { number: 8, title: "Pending orders" },
  payroll: { number: 9, title: "Payroll" },
  cctv: { number: 10, title: "CCTV" },
};

export const BOSS_DASHBOARD_EVENT_TYPES = [
  "session_start",
  "session_end",
  "page_view",
  "action",
  "app_background",
  "app_resumed",
];

function humanizePageId(pageId) {
  return String(pageId || "")
    .trim()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** @param {string} [pageId] @param {string} [storedTitle] */
export function bossDashboardPageTitle(pageId, storedTitle) {
  const stored = String(storedTitle || "").trim();
  if (stored) return stored;
  const id = String(pageId || "").trim();
  if (!id) return "—";
  return BOSS_DASHBOARD_PAGE_META[id]?.title || humanizePageId(id);
}

/** @param {string} [pageId] @param {number} [storedNumber] */
export function bossDashboardPageNumber(pageId, storedNumber) {
  if (storedNumber != null && Number.isFinite(Number(storedNumber))) return Number(storedNumber);
  const id = String(pageId || "").trim();
  if (!id) return null;
  const n = BOSS_DASHBOARD_PAGE_META[id]?.number;
  return n != null ? n : null;
}
